import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { ThirdPartyQuestionnaireProvider } from "../../Context/thirdPartyQuestionnaireContext";
import { useDashboardInfo } from "../../Context/dashboardContext";

const ThirdPartyQuestionnaireLayout = () => {
    const { currentActiveEnvironment } = useDashboardInfo();

    if(currentActiveEnvironment === "Production") {
        return <Navigate to={'/not-found'} replace />;
    }

    return (
        <>
            <ThirdPartyQuestionnaireProvider>
                <Outlet />
            </ThirdPartyQuestionnaireProvider>
        </>
    );
};

export default ThirdPartyQuestionnaireLayout;